export const PAYEE_ACTIVITY_TYPE_INVOICE_PAID = "INVOICE_PAID"
export const PAYEE_ACTIVITY_TYPE_INVOICE_PARTIALLY_PAID = "INVOICE_PARTIALLY_PAID"
export const PAYEE_ACTIVITY_TYPE_ONE_TIME_PAYMENT_RECEIVED = "ONE_TIME_PAYMENT_RECEIVED"
export const PAYEE_ACTIVITY_TYPE_PAYEE_ORDER_PAYMENT_RECEIVED = "PAYEE_ORDER_PAYMENT_RECEIVED"
export const PAYEE_ACTIVITY_TYPE_DISBURSEMENT_COMPLETED = "DISBURSEMENT_COMPLETED"